export default __webpack_public_path__ + "static/media/ic_llp_24.b302b333.svg";